import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes as RRRoutes } from "react-router-dom";
import { PrincipalProvider } from "areas/account/components/PrincipalProvider";
import paths from "paths.json";
import { CloseLoadingScreenOnUnmount } from "areas/layout/components/CloseLoadingScreenOnUnmount";
import { ErrorBoundary } from "areas/layout/components/ErrorBoundary";
import { DefaultTheme, ThemeProvider } from "styled-components";
import { GoogleAnalytics } from "areas/layout/components/GoogleAnalytics";
import { InternetOfflineMessage } from "areas/layout/components/InternetOfflineMessage";
import { componentLoaderWithRetry } from "areas/common/utilities/componentLoaderWithRetry";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Signin = componentLoaderWithRetry(() => import("areas/account/components/Signin"), 3);
const Signout = componentLoaderWithRetry(() => import("areas/account/components/Signout"), 3);
const Profile = componentLoaderWithRetry(() => import("areas/account/components/Profile"), 3);
const StandardPage = componentLoaderWithRetry(() => import("areas/layout/components/StandardPage"), 3);

const App = () => {
  const theme: DefaultTheme = {
    primaryColor: "#0099cc",
    notificationsIconColor: "#50718d",
    navItemHoverBackgroundColor: "#666",
    primaryButtonColor: "#0099cc",
  };

  return (
    <>
      <ErrorBoundary>
        <ThemeProvider theme={theme}>
          <PrincipalProvider>
              <Router>
                <Suspense fallback={<CloseLoadingScreenOnUnmount />}>
                  <RRRoutes>
                    {/* These 3 routes are special, they display in the full browser window. All normal routes should go in Routes.tsx */}
                    <Route
                      path={paths.Account.Signin}
                      element={<Signin />}
                    />
                    <Route
                      path={paths.Account.Signout}
                      element={<Signout />}
                    />
                    <Route
                      path={paths.Account.Profile}
                      element={<Profile />}
                    />
                    <Route path="*" element={<StandardPage />} />
                  </RRRoutes>
                </Suspense>
                <GoogleAnalytics />
              </Router>
          </PrincipalProvider>
          <InternetOfflineMessage />
        </ThemeProvider>
        <ToastContainer autoClose={3000} hideProgressBar={false} position="top-right" />
      </ErrorBoundary>
    </>
  );
};

export default App;
